<template>
    <form @submit.prevent="submitForm">
        <div class="row">
            <div class="col-md-6">

                <field-text required v-model="form.title" label="عنوان" placeholder=""/>
                <field-text required v-model="form.x" label="فاصله از چپ" placeholder=""/>
                <field-text required v-model="form.y" label="فاصله از بالا" placeholder=""/>
                <field-markdown required v-model="form.description" label="توضیحات" placeholder=""/>
            </div>
            <div class="col-md-6">
                <field-image  required v-model="form.image_src" link="/fa/v1/agencies/upload-image"  placeholder=""/>
            </div>
        </div>

        <alert :success="success" :danger="danger"></alert>
        <button-submit title="ثبت"/>
    </form>
</template>

<script>
import ButtonSubmit from "../ButtonSubmit";
import Alert from "../Alert";
import FieldPassword from "../fields/FieldPassword";
import FieldMobile from "../fields/FieldMobile";
import FieldEmail from "../fields/FieldEmail";

import mixinForm from "../../mixins/mixinForm";
import FieldSelect from "../fields/FieldSelect";
import FieldText from "../fields/FieldText";
import FieldTextarea from "../fields/FieldTextarea";
import FieldImage from "../fields/FieldImage";
import FieldMarkdown from "../fields/FieldMarkdown";

export default {
  mixins: [mixinForm],
  components: {
    FieldMarkdown,
    FieldImage,
    FieldTextarea,
    FieldSelect,
    FieldText,
    FieldEmail,
    FieldMobile,
    FieldPassword,
    Alert,
    ButtonSubmit
  },
  name: "FormAgencie",
  data() {
    return {
      action: "/fa/v1/agencies"
    };
  }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/forms/FormAgencie.vue